<!-- <popup-warn *ngIf="errMessageVisible" [message]="errMessage" (action)="navigateHome()">
</popup-warn> -->
<div class="bg-verify">
  <div class="top-logo">
    <img
      class="logo-left"
      [src]="'assets/img/unilever-logo-w.png'"
      alt=""
    />
    <img
      class="logo-right"
      [src]="'assets/img/header_logo.png'"
      alt=""
    />
  </div>
  <div class="main-image">
    <img [src]="'assets/img/browser/1.png'" alt="" />
  </div>
  <div class="loading">
    <!-- <div class="center">
      <div class="wave"></div>
      <div class="wave"></div>
      <div class="wave"></div>
    </div> -->
    <p>Vui lòng sử dụng trình duyệt Safari để có thể truy cập trang web này</p>
    <div class="btn-inline-center">
      <button type="button" (click)="openSafari()" class="btn btn-second">
        <span>Mở Safari</span>
      </button>
    </div>
  </div>
  <div class="bottom-image">
    <img
      class="img-bg"
      [src]="'assets/img/browser/asset_2.png'"
      alt=""
    />
    <img
      class="people-1"
      [src]="'assets/img/browser/Asset_1_1.png'"
      alt=""
    />
    <img
      class="people-2"
      [src]="'assets/img/browser/Asset_1_2.png'"
      alt=""
    />
    <img
      class="people-3"
      [src]="'assets/img/browser/Asset_1_3.png'"
      alt=""
    />
  </div>
</div>

